import UserCreateForm from './UserCreateForm'

export default UserCreateForm
